import { render, staticRenderFns } from "./Tab-IIIb.vue?vue&type=template&id=4e61b358"
import script from "./Tab-IIIb.vue?vue&type=script&lang=js"
export * from "./Tab-IIIb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports